import { useContext } from 'react';

import './style.css';
import LoadingSpinner from '../shared/components/UIElements/LoadingSpinner';
import { AuthContext } from '../shared/context/auth-context';
import { HeaderNavigation } from '../shared/headerNavigation/HeaderNavigation';
import { useAuth } from '../shared/hooks/auth-hook';
import { useHttpClient } from '../shared/hooks/http-hook';

export function Settings() {
  const auth = useContext(AuthContext);
  const { isLoading, error } = useHttpClient();
  const { tags } = useAuth();

  return (
    <div className="settings-page">
      <HeaderNavigation />

      {isLoading && <LoadingSpinner />}
      {!auth.isLoggedIn && error && <p>Invalid log in. Please try again.</p>}
      {auth.isLoggedIn && tags && (
        <div>
          <ul>
            {/* only if tags is an array */}
            {Array.isArray(tags) &&
              tags.map((item: string) => {
                return <li>{item}</li>;
              })}
          </ul>
        </div>
      )}
    </div>
  );
}
